import { useState } from "react";
import { loginUser } from "../api/api";
import { useNavigate } from "react-router-dom";

function Login() {
  const [form, setForm] = useState({});
  const navigate = useNavigate();

  const handleLogin = async () => {
    const res = await loginUser(form);

    localStorage.setItem("token", res.access_token);
    navigate("/dashboard");
  };

  return (
    <div className="form">
      <h2>Login</h2>

      <input placeholder="Email"
        onChange={(e)=>setForm({...form,email:e.target.value})} />

      <input type="password" placeholder="Password"
        onChange={(e)=>setForm({...form,password:e.target.value})} />

      <button onClick={handleLogin}>Login</button>
    </div>
  );
}

export default Login;